export enum LocationType {
    DC = 'dc',
    Store = 'store'
  };